/* Wrought polish layer: reveal, rise, hover swap, ship-by timeline, October badges. */
(function () {
  // Production + shipping estimates in business days. Adjust to match Printful.
  var MAKE_DAYS = 5;
  var SHIP_MIN = 3;
  var SHIP_MAX = 5;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  // ---------- Manifesto word reveal ----------
  function initReveal() {
    var section = document.querySelector('[id$="__section_JpEEkW"]');
    if (!section || reduce) return;
    var words = [];
    $$('p', section).forEach(function (p) {
      if (p.dataset.wrSplit) return;
      p.dataset.wrSplit = '1';
      var walker = document.createTreeWalker(p, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        var frag = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) {
            frag.appendChild(document.createTextNode(part));
          } else {
            var s = document.createElement('span');
            s.className = 'wr-w';
            s.textContent = part;
            frag.appendChild(s);
            words.push(s);
          }
        });
        node.parentNode.replaceChild(frag, node);
      });
    });
    if (!words.length) return;

    var ticking = false;
    function paint() {
      ticking = false;
      var line = window.innerHeight * 0.62;
      for (var i = 0; i < words.length; i++) {
        words[i].classList.toggle('is-lit', words[i].getBoundingClientRect().top < line);
      }
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(paint);
      }
    }
    // Capture scrolls from the theme's .page-wrapper scroller as well as the window.
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll, { passive: true });
    paint();
  }

  // ---------- Staggered rise ----------
  var io =
    'IntersectionObserver' in window && !reduce
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                e.target.classList.add('is-in');
                io.unobserve(e.target);
              }
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
        )
      : null;

  function rise(els) {
    if (!io) return;
    els.forEach(function (el, i) {
      if (el.classList.contains('wr-rise')) return;
      // Skip anything already on screen so nothing blinks on load.
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return;
      el.classList.add('wr-rise');
      el.style.transitionDelay = (i % 4) * 90 + 'ms';
      io.observe(el);
    });
  }

  function initRise() {
    if (!io) return;
    document.documentElement.classList.add('wr-js');
    rise($$('main product-card'));
    var values = document.querySelector('[id$="__section_x8mrnx"]');
    if (values) rise($$('h1, h2, h3, h4, p', values));
  }

  // ---------- Product card: hover image swap + October badge ----------
  function cardTitle(card) {
    try {
      return JSON.parse(card.getAttribute('view-event-payload')).product.title || '';
    } catch (e) {
      return '';
    }
  }

  function enhanceCard(card) {
    if (card.dataset.wrDone) return;
    card.dataset.wrDone = '1';
    var gallery = card.querySelector('.card-gallery');
    if (!gallery) return;
    if (getComputedStyle(gallery).position === 'static') gallery.style.position = 'relative';

    var imgs = $$('img', gallery);
    if (imgs.length > 1 && window.matchMedia('(hover: hover)').matches) {
      var second = imgs[1];
      var src = second.currentSrc || second.getAttribute('src') || '';
      if (!src && second.getAttribute('srcset')) src = second.getAttribute('srcset').split(' ')[0];
      if (src) {
        src = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
        var alt = new Image();
        alt.className = 'wr-alt';
        alt.alt = '';
        alt.decoding = 'async';
        alt.loading = 'lazy';
        alt.onload = function () {
          alt.classList.add('is-ready');
        };
        alt.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=800';
        gallery.appendChild(alt);
      }
    }

    if (/blackout|obsidian/i.test(cardTitle(card))) {
      var b = document.createElement('span');
      b.className = 'wr-badge';
      b.textContent = 'Blackout';
      gallery.appendChild(b);
    }
  }

  function initCards() {
    $$('product-card').forEach(enhanceCard);
    // Cards added later (filters, infinite scroll, recommendations).
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('product-card')) enhanceCard(n);
          if (n.querySelectorAll) $$('product-card', n).forEach(enhanceCard);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // ---------- Ship-by timeline ----------
  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) n--;
    }
    return d;
  }

  function initShipBy() {
    var main = document.querySelector('main[data-template^="product"]');
    if (!main || main.querySelector('.wr-ship')) return;
    var form = main.querySelector('form.shopify-product-form');
    if (!form) return;

    var now = new Date();
    var made = addBusinessDays(now, MAKE_DAYS);
    var a1 = addBusinessDays(made, SHIP_MIN);
    var a2 = addBusinessDays(made, SHIP_MAX);
    var long = { weekday: 'short', month: 'short', day: 'numeric' };
    var short = { month: 'short', day: 'numeric' };
    var f = function (d, o) { return d.toLocaleDateString('en-US', o); };

    var box = document.createElement('div');
    box.className = 'wr-ship';
    box.innerHTML =
      '<div class="wr-ship__hd">Order today, ships by <b>' + f(made, long) + '</b></div>' +
      '<div class="wr-ship__row">' +
      '<div class="wr-ship__st"><div class="wr-ship__dot"></div><div class="wr-ship__lb">Ordered</div><div class="wr-ship__dt">Today</div></div>' +
      '<div class="wr-ship__st"><div class="wr-ship__dot"></div><div class="wr-ship__lb">Made for you</div><div class="wr-ship__dt">By ' + f(made, short) + '</div></div>' +
      '<div class="wr-ship__st"><div class="wr-ship__dot"></div><div class="wr-ship__lb">Delivered</div><div class="wr-ship__dt">' + f(a1, short) + ' – ' + f(a2, short) + '</div></div>' +
      '</div>' +
      '<div class="wr-ship__ft">Made to order. Nothing sits on a shelf.</div>';
    form.parentNode.insertBefore(box, form.nextSibling);
  }

  // ---------- Seasonal header ----------
  var PUMPKIN =
    '<path d="M20 7 C19 4 20 2 23 1" fill="none" stroke="#6b5a36" stroke-width="2.2" stroke-linecap="round"/>' +
    '<ellipse cx="11" cy="21" rx="9.5" ry="13" fill="#b8481f"/><ellipse cx="29" cy="21" rx="9.5" ry="13" fill="#b8481f"/>' +
    '<ellipse cx="20" cy="21" rx="10" ry="14" fill="#d85a30"/>' +
    '<path d="M14.5 9 Q12 21 14.5 33 M25.5 9 Q28 21 25.5 33" fill="none" stroke="#8f3616" stroke-width="1"/>' +
    '<path class="carve" d="M20 11.5 L21.1 14 L21.1 25 L20 29 L18.9 25 L18.9 14 Z M16.2 16.2 L23.8 16.2 L23.8 17.6 L16.2 17.6 Z"/>';

  function initPumpkins() {
    if (!document.documentElement.classList.contains('wr-october')) return;
    var box = document.querySelector('#header-component .header-logo__image-container');
    if (!box || box.querySelector('.wr-pumpkin')) return;
    ['wr-pumpkin--l', 'wr-pumpkin--r'].forEach(function (cls) {
      box.insertAdjacentHTML('beforeend', '<svg class="wr-pumpkin ' + cls + '" viewBox="0 0 40 36" aria-hidden="true">' + PUMPKIN + '</svg>');
    });
  }

  function initLights() {
    if (!document.documentElement.classList.contains('wr-december')) return;
    var header = document.querySelector('#header-component');
    if (!header) return;
    var colors = ['#e8b04a', '#c94a3a', '#3f8f5a', '#f2ede1'];
    function draw() {
      var old = header.querySelector('.wr-lights');
      if (old) old.remove();
      var w = Math.round(header.getBoundingClientRect().width);
      if (!w) return;
      var span = 70, n = Math.ceil(w / span), d = 'M0 4', bulbs = '', k = 0;
      for (var i = 0; i < n; i++) {
        var x0 = i * span;
        d += ' Q' + (x0 + span / 2) + ' 20 ' + (x0 + span) + ' 4';
        [0.3, 0.5, 0.7].forEach(function (t) {
          var x = x0 + span * t;
          var y = (1 - t) * (1 - t) * 4 + 2 * (1 - t) * t * 20 + t * t * 4;
          var c = colors[k % colors.length];
          bulbs += '<g class="bulb" style="animation-delay:' + ((k * 0.37) % 3).toFixed(2) + 's">' +
            '<rect x="' + (x - 1.6) + '" y="' + y + '" width="3.2" height="3" fill="#2a2a28"/>' +
            '<ellipse cx="' + x + '" cy="' + (y + 7) + '" rx="3" ry="4.4" fill="' + c + '"/>' +
            '<circle cx="' + x + '" cy="' + (y + 7) + '" r="7" fill="' + c + '" opacity=".18"/></g>';
          k++;
        });
      }
      header.insertAdjacentHTML('beforeend',
        '<svg class="wr-lights" viewBox="0 0 ' + w + ' 26" preserveAspectRatio="none" aria-hidden="true">' +
        '<path d="' + d + '" fill="none" stroke="#2a2a28" stroke-width="1.2"/>' + bulbs + '</svg>');
    }
    draw();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(draw, 200); }, { passive: true });
  }

  function initHero() {
    var hero = document.querySelector('main .hero-wrapper');
    if (!hero) return;
    hero.classList.add('wr-hero-first');
    if (document.documentElement.classList.contains('wr-october') && !hero.querySelector('.wr-fog')) {
      if (getComputedStyle(hero).position === 'static') hero.style.position = 'relative';
      hero.insertAdjacentHTML('beforeend',
        '<div class="wr-fog" aria-hidden="true"><div class="wr-fog__layer"></div><div class="wr-fog__layer wr-fog__layer--2"></div></div>');
    }
  }

  ready(function () {
    try { initHero(); } catch (e) {}
    try { initReveal(); } catch (e) {}
    try { initCards(); } catch (e) {}
    try { initRise(); } catch (e) {}
    try { initShipBy(); } catch (e) {}
    try { initPumpkins(); } catch (e) {}
    try { initLights(); } catch (e) {}
  });
})();
